import * as React from 'react';
import { CommonIcons } from 'components/Icons';
import { SIZE_ICON } from 'consts/data';
import { copyToClipboard } from 'helpers';
import { notifySuccess } from 'helpers/handleNotification';
import { useTranslation } from 'react-i18next';
import { cn } from 'helpers/css';
import { TooltipReactTooltip } from 'components/Tooltip';

const Copy = ({ onClick, classNameContainer, className, text = '', tooltip, style, size }) => {
  //! State
  const { t } = useTranslation();

  //! Function
  const onClickCopy = () => {
    copyToClipboard(text);
    notifySuccess(`${t('shared:copied')}!`);
  };

  //! Render
  return (
    <TooltipReactTooltip
      v2Options={{
        className: classNameContainer,
      }}
      messageToolTip={tooltip || t('shared:copy')}
    >
      <CommonIcons.Copy
        onClick={onClick || onClickCopy}
        size={size || SIZE_ICON}
        className={cn('icon-copy is-hover icon-dzb', className)}
        style={style}
      />
    </TooltipReactTooltip>
  );
};

export default Copy;
